/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useState, useEffect } from "react";
import { useGLTF, Plane } from "@react-three/drei";
import { MathUtils, Box3, Vector3 } from 'three';
import { useSpring, a, config } from '@react-spring/three';

export function HTML5(props) {
    const [isHovered, setIsHovered] = useState(false);
    const currentRotation = useRef(MathUtils.degToRad(-100))
    const [planeSize, setPlaneSize] = useState([1, 1]);
    const groupRef = useRef(); // Reference to the group

    const { rotation } = useSpring({
        from: {
        rotation: currentRotation.current
        },
        config: config.wobbly
    })
    const { nodes } = useGLTF("/models/html5_model.glb");

    useEffect(() => {
        if (groupRef.current) {
            const boundingBox = new Box3().setFromObject(groupRef.current);
            const size = new Vector3();
            boundingBox.getSize(size);
            setPlaneSize([size.x + 0.5, size.y + 0.5]); // Update state with the new size
        }
    }, [props.scale]);

    useEffect(() => {
        if(isHovered){
            rotation.start({
                to: currentRotation.current + MathUtils.degToRad(50)
            })
        } else {
            rotation.start({
                to: MathUtils.degToRad(-100)
            })
        }
    }, [isHovered, rotation])

    return (
        <>
        <Plane
            args={planeSize}
            position={[props.position[0], props.position[1], props.position[2]]}
            onPointerOver={() => setIsHovered(true)}
            onPointerOut={() => setIsHovered(false)}
            visible={props.showBox}
        />
        <a.group {...props} 
            dispose={null} 
            ref={groupRef}
            scale={[(0.5 * props.scale), (0.5 * props.scale), (0.45 * props.scale)]}
            rotation={[0, MathUtils.degToRad(-100), 0]}
            rotation-y={rotation}
            onPointerOver={() => {
                rotation.start({
                to: currentRotation.current + MathUtils.degToRad(50)
                })
            }}
            onPointerOut={() => {
                rotation.start({
                to: MathUtils.degToRad(-100)
                })
            }}
        >
        <group
            position={[-0.01, -0.905, -0.024]}
            rotation={[-Math.PI / 2, 0.006, 0]}
            scale={0.374}
        >
            <group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
            <group
                position={[11.813, 52.914, -1.08]}
                rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                scale={82.789}
            >
                <mesh
                castShadow
                receiveShadow
                geometry={nodes["Plane001_orange-lite_0"].geometry}
                // material={materials["orange-lite.001"]}
                >
                <meshPhysicalMaterial 
                    color='#E3422A'
                    metalness={0}
                    roughness={0.5}
                    clearcoat={0.8}
                />
                </mesh>
                <mesh
                castShadow
                receiveShadow
                geometry={nodes.Plane001_orange_0.geometry}
                // material={materials["orange.001"]}
                >
                <meshPhysicalMaterial 
                    color='#E3422A'
                    metalness={0}
                    roughness={0.5}
                    clearcoat={0.8}
                />
                </mesh>
            </group>
            <mesh
                castShadow
                receiveShadow
                geometry={nodes["Plane_escudo-2_0"].geometry}
                // material={materials["escudo-2.001"]}
                position={[0, 0, -1.08]}
                rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                scale={100}
                >
                <meshPhysicalMaterial 
                    color='#E3422A'
                    metalness={0}
                    roughness={0.5}
                    clearcoat={0.8}
                />
            </mesh>
            <mesh
                castShadow
                receiveShadow
                geometry={nodes.Plane002_five_0.geometry}
                // material={materials["five.001"]}
                position={[61.853, 307.492, 35.171]}
                rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                scale={100}
                >
                <meshPhysicalMaterial 
                    color='white'
                    metalness={0}
                    roughness={0.5}
                />
            </mesh>
            </group>
        </group>
        </a.group>
        </>
  );
}

useGLTF.preload("/models/html5_model.glb");
